export const theme = {
    color: {
        white: "#FFFFFF",
        jaggedIce: "#C5E4E7",
        whiteSqueeze: "#F3F9FA",
        cuttySark: "#5E7A7D",
        prettyShark: "#547878",
        sherpaBlue: "#00474B",
        java: "#26C2AE",
        towerGray: "#9EBBBD",
        grannySmith: "#7F9D9F",
        william: "#3D6666",
        terracotta: "#E17052",
        waterLeaf: "#9FE8DF",
        atoll: "#0D686D",
    },
    breakpoint: {
        mobile: 767,
    },
};